package com.milta.feature.team.data.remote

import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.core.network.ApiException
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.team.data.remote.dto.DriverDto
import com.milta.feature.team.data.remote.dto.EnterpriseDto
import com.milta.feature.team.data.remote.dto.LinkDriverRequest
import com.milta.feature.team.data.remote.dto.TeamMembershipDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess

class TeamApi(private val client: HttpClient) {

    suspend fun getMyTeam(): List<TeamMembershipDto> {
        val response = client.get("$baseUrl/${Endpoints.myTeam}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    /** GET /api/v1/enterprises/{enterpriseId}/drivers — assignable drivers for MIL-37 route creation. */
    suspend fun getDrivers(enterpriseId: String): List<DriverDto> {
        val response = client.get("$baseUrl/${Endpoints.enterpriseDrivers(enterpriseId)}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    /** POST /api/v1/enterprises/{enterpriseId}/team/link — MIL-49, links a driver via their one-time code. */
    suspend fun linkDriver(enterpriseId: String, code: String): DriverDto {
        val response = client.post("$baseUrl/${Endpoints.teamLink(enterpriseId)}") {
            contentType(ContentType.Application.Json)
            setBody(LinkDriverRequest(code = code))
        }
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    /** DELETE /api/v1/enterprises/{enterpriseId}/team/{driverId} — MIL-49, breaks the Membership only. */
    suspend fun removeDriver(enterpriseId: String, driverId: String) {
        val response = client.delete("$baseUrl/${Endpoints.teamMember(enterpriseId, driverId)}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }

    /** GET /api/v1/enterprises/me — MIL-53, read-only Organisation profile (Dashboard Web Paramètres). */
    suspend fun getMyEnterprise(): EnterpriseDto {
        val response = client.get("$baseUrl/${Endpoints.myEnterprise}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    /** DELETE /api/v1/enterprises/me — MIL-53, permanently deletes the calling Gestionnaire's Organisation. */
    suspend fun deleteMyEnterprise() {
        val response = client.delete("$baseUrl/${Endpoints.myEnterprise}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }
}
